import { Component, OnInit, Input, EventEmitter, Output, OnChanges, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'app-multi-filter',
  templateUrl: './multi-filter.component.html',
  styleUrls: ['./multi-filter.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MultiFilterComponent implements OnInit {
  @Input() contentTypes: string[];
  @Input() projectGridViews: any;
  @Input() organizations: any;
  @Input() organizationFlag: any;
  @Input() userRole: any;
  @Input() selectedView: any;
  @Input() selectedOrganization: any;
  @Output() applyFilterAttributes = new EventEmitter<any>();
  @Input() selectedContentType: any;
  public formData: UntypedFormGroup;
  constructor() { }

  ngOnInit() {
    this.formData = new UntypedFormGroup({
      org: new UntypedFormControl(this.selectedOrganization ? this.selectedOrganization.id : this.organizations[0]),
      content: new UntypedFormControl(this.selectedContentType ? this.selectedContentType : this.contentTypes[0]),
      status: new UntypedFormControl(this.selectedView === '' || this.selectedView === null ? 'Pending' : this.selectedView.name)
    });
  }
  ngAfterContentChecked() {
  }
  ngAfterContentInit() {
    this.formData.controls.org.setValue(this.selectedOrganization ? this.selectedOrganization.id : this.organizations[0]);
  }
  // tslint:disable-next-line: use-life-cycle-interface

  changeContentType(contentType: string) {
    this.selectedContentType = contentType;
  }
  changeGridView(projectView: any) {
    this.selectedView = projectView;
    this.applyFilter();
  }
  onChangeOrganization(organizationId: any) {
    if (organizationId !== undefined) {
      this.selectedOrganization = this.organizations.filter(x => x.id == organizationId)[0];
    }
  }
  applyFilter() {
    this.applyFilterAttributes.emit();
  }
}
